import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/collaboration_analytics_event.py
export const COLLABORATION_ANALYTICS_ACTIONS = {
  RECEIVED_REALTIME_UPDATE: {
    module: ANALYTICS_MODULE.COLLABORATION,
    action: 'received_realtime_update',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ENTERED_PRESENCE: {
    module: ANALYTICS_MODULE.COLLABORATION,
    action: 'entered_presence',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXITED_PRESENCE: {
    module: ANALYTICS_MODULE.COLLABORATION,
    action: 'exited_presence',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
